(ns ycweb.app.admin.wholesale.stockorders.overview
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.admin.wholesale.importorders.common :as io.cmn]
   [ycweb.app.admin.wholesale.stockorders.common :as so.cmn]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.order.order :as order.tab]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.order.config :as order.cfg]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.attachments.wrapper :as attachments]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.creditnote.wrapper :as creditnote.wrapper]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.invoice.invoiceform :as invoice.form]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.manualjournals.manualjournals :as manualjournals]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.stockreceived.wrapper :as stockreceived.wrapper]
   [ycweb.app.admin.wholesale.stockorders.overview.tabs.changelogs.changelogs :as changelogs]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as form]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.tabs :as tabs]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

;;------------------------------------------------------------------------------------------------------------------------------
;; Stock Order : Overview
;;------------------------------------------------------------------------------------------------------------------------------

(defn translate-order-status [status stockorder-items]
  (case status
    "Draft" (if (seq stockorder-items) "Ordering" "Draft")
    "Placed" "Ordered"
    "Prereceived" "Ordered"
    "Received" "Received"
    "Cancelled" "Cancelled"
    "None"))

(rum/defc display-stockorder-integration-status < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder (cmn/curact action-atom :stockorder)
        invoice (cmn/curact action-atom :invoice)
        order-status (:stockorder/status stockorder)
        stockorder-items (cmn/curact action-atom :order.table)
        receiving-status (so.cmn/calculate-receiving-status action-atom)]

    [:div
     {:class (yuc/bem :flex-grid-group [:flush :align-right :valign-middle])}
     [:div
      {:class (yuc/bem :flex-grid-block [:fluid])}
      [:div.flex-grid-content
       [:table
        {:class (yuc/bem :oTable [:has-shadow])}
        [:thead
         [:tr
          [:th.u-text-center "Order Status"]
          [:th.u-text-center "Invoice Status"]
          [:th.u-text-center "Receiving Status"]]]
        [:tbody
         [:tr
          [:td.u-text-center
           [:p.admin-action-item__count-wrapper
            [:span.admin-action-item__count (translate-order-status order-status stockorder-items)]]]
          [:td.u-text-center
           [:p.admin-action-item__count-wrapper
            [:span.admin-action-item__count (or (:status invoice) "N/A")]]]
          [:td.u-text-center
           [:p.admin-action-item__count-wrapper
            [:span.admin-action-item__count receiving-status]]]]]]]]]))

(rum/defc supplier-details < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder-atom (rum/cursor action-atom :stockorder)
        stockorder (rum/react stockorder-atom)
        suppliers (cmn/curact action-atom :suppliers)
        suppliers-idx (yuc/index-by :id suppliers)
        supplier-addresses (cmn/curact action-atom :supplier-addresses)
        supplier-addresses-idx (yuc/index-by :id supplier-addresses)
        supplier-contacts (cmn/curact action-atom :supplier-contacts)
        supplier-contacts-idx (yuc/index-by :id supplier-contacts)
        supplier-contact (get supplier-contacts-idx (:stockorder/supplier_contact_id stockorder))
        order-cancelled? (= (:stockorder/status stockorder) "Cancelled")]

    [:<>
     (headings/heading "Supplier details" {:type :h4 :size :small})

     [:div.form-field
      (rum/with-key
        (w.cmn/form-radio action-atom :stockorder :stockorder/import_order? "Freight Forwarding"
          {:disabled?
           (or
             order-cancelled?
             (not (cmn/has-any-permission? app-atom io.cmn/import-order-edit-permission))
             (trf/toboolean
               (yuc/presence (:stockorder/import_order_id stockorder))))})
        "freight-forwarding")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select action-atom :stockorder :stockorder/supplier_id "Supplier:"
          (concat
            [{:text "- Select -" :value nil}]
            (map
              (fn [v]
                {:text (:name v) :value (:id v)})
              suppliers))
          {:disabled order-cancelled?
           :change-fn
           (fn [_n v]
             (let [{:keys [taxrule_id paymentterm_id currencycode]}
                   (get suppliers-idx (trf/tonumber v))]
               (swap! stockorder-atom assoc
                 :stockorder/taxrule_id taxrule_id
                 :stockorder/paymentterm_id paymentterm_id
                 :stockorder/currencycode currencycode
                 :stockorder/currencyrate (if (= currencycode "ZAR") 1 0))
               (when (not= currencycode "ZAR")
                 (grid/dispatch-action app-atom :stockorder/supplier-details
                   {:supplier/id (trf/tonumber v)}))))})
        "supplier")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select action-atom :stockorder :stockorder/supplier_contact_id "Contact:"
          (concat
            [{:text "- Select -" :value nil}]
            (map
              (fn [v]
                {:text (:name v) :value (:id v)})
              supplier-contacts))
          {:disabled order-cancelled?})
        "contact")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-input action-atom :stockorder
          (if (yuc/presence (:stockorder/tel supplier-contact))
            :stockorder/tel
            :stockorder/cell)
          "Phone:" ""
          {:disabled order-cancelled?})
        "contact-phone")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select action-atom :stockorder :stockorder/supplier_address_id "Address line 1:"
          (concat
            [{:text "- Select -" :value nil}]
            (map
              (fn [v]
                {:text (:billing-display-line-1 v)
                 :value (:id v)})
              supplier-addresses))
          {:disabled order-cancelled?
           :change-fn
           (fn [_n v]
             (swap! stockorder-atom assoc
               :stockorder/display-line-2
               (:billing-display-line-2
                (get supplier-addresses-idx (trf/tonumber v)))))})
        "address-line-1")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-input action-atom :stockorder :stockorder/display-line-2 "Address line 2:" ""
          {:disabled order-cancelled?})
        "address-line-2")]]))

(defmethod grid/action :stockorder/supplier-details [app-atom config _]
  (toaster/open-overlay app-atom :admin.wholesale/stock-order.overview)
  (comms/send :admin.wholesale/stockorder.supplier-details config))

(defmethod comms/receive :admin.wholesale/stockorder.supplier-details
  [app-atom {:keys [freight-forwarders supplier-addresses supplier-contacts stockorder]}]
  (toaster/close-overlay app-atom :admin.wholesale/stock-order.overview)
  (let [action-name (cmn/action-cursor-path app-atom)]
    (swap! app-atom update action-name
      (fn [action]
        (->
          action
          (update :stockorder #(merge % stockorder))
          (assoc
            :freight-forwarders freight-forwarders
            :supplier-addresses supplier-addresses
            :supplier-contacts supplier-contacts))))))

(rum/defc accounting-details < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        page (cmn/action-cursor-path app-atom)
        stockorder-atom (rum/cursor action-atom :stockorder)
        stockorder (rum/react stockorder-atom)
        inventory-account (cmn/curact action-atom :inventory-account)
        form-atom (rum/cursor-in action-atom [:form :stockorder])
        payment-terms (cmn/curact action-atom :payment-terms)
        tax-rules (cmn/curact action-atom :tax-rules)
        order-cancelled? (= (:stockorder/status stockorder) "Cancelled")]

    [:<>
     (headings/heading "Accounting details" {:type :h4 :size :small})

     [:div
      [:div
       {:class (yuc/bem :flex-grid-group [:align-left :flush-force])}
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         (form/radio "Stock First" "STOCK" (rum/cursor stockorder-atom :stockorder/approach)
           {:name :stockorder/type
            :disabled true})]]
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         (form/radio "Invoice First" "INVOICE" (rum/cursor stockorder-atom :stockorder/approach)
           {:name :stockorder/type
            :disabled true})]]]
      (form/error-block (rum/cursor form-atom :stockorder/approach))]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select action-atom :stockorder :stockorder/paymentterm_id "Terms:"
          (concat
            [{:text "- Select -" :value nil}]
            (map
              (fn [v]
                {:text (:description v) :value (:id v)})
              payment-terms))
          {:disabled order-cancelled?})
        "payment-terms")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-date app-atom page :stockorder :stockorder/dateexpected "Required By:"
          {:disabled? order-cancelled?})
        "required-by")]

     (when (not= (:stockorder/currencycode stockorder) "ZAR")
       (let [currency-error (cmn/curact action-atom [:form :stockorder :stockorder/currencyrate :error])]
         [:div
          {:class (yuc/bem :form-field (when currency-error [:error]))}
          [:div.text-input-wrapper
           (form/field-label
             (str "ZAR units per "
               (:stockorder/currencycode stockorder)
               ". Last updated: "
               (:stockorder/currencyratedate stockorder)) {})
           [:div.input-combo
            (form/input-raw "" (rum/cursor-in action-atom [:stockorder :stockorder/currencyrate])
              {:disabled order-cancelled?})
            (buttons/button-web ""
              {:style :primary
               :combo true
               :icon :refresh
               :icon-only true
               :on-click
               #(grid/dispatch-action app-atom :stockorder/currency-rate
                  {:from (:stockorder/currencycode stockorder)
                   :to "ZAR"})
               :disabled order-cancelled?})]
           (form/error-block (rum/cursor-in action-atom [:form :stockorder :stockorder/currencyrate :error]))]]))

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select action-atom :stockorder :stockorder/inventory-account-id
          "Inventory Account:"
          [{:text (str (:code inventory-account) ": " (:account_name inventory-account)) :value (:code inventory-account)}]
          {:disabled true})
        "inventory-account")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select action-atom :stockorder :stockorder/taxrule_id
          "Tax Rule:"
          (map
            (fn [tax-rule]
              {:text (str (:description tax-rule)) :value (:id tax-rule)})
            tax-rules)
          {})
        "tax-rule")]]))

(defmethod grid/action :stockorder/currency-rate [app-atom config _]
  (toaster/open-overlay app-atom :admin.wholesale/stock-order.overview)
  (comms/send :admin.wholesale/import-order.currency-rate config))

(defmethod comms/receive :admin.wholesale/import-order.currency-rate [app-atom e]
  (toaster/close-overlay app-atom :admin.wholesale/stock-order.overview)
  (let [action-atom (cmn/action-cursor app-atom)
        {:keys [rate last-updated]} (:current/rate e)]
    (swap! action-atom update :stockorder
      (fn [stockorder]
        (assoc stockorder
          :stockorder/currencyrate rate
          :stockorder/currencyratedate last-updated)))))

(rum/defc shipping-details < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        page (cmn/action-cursor-path app-atom)
        stockorder-atom (rum/cursor action-atom :stockorder)
        form-atom (rum/cursor-in action-atom [:form :stockorder])
        warehouses (cmn/curact action-atom :warehouses)
        warehouses-idx (yuc/index-by :id warehouses)
        order-cancelled? (= (:stockorder/status @stockorder-atom) "Cancelled")]
    [:<>
     (headings/heading "Shipping details" {:type :h4 :size :small})

     [:div
      {:class (yuc/bem :form-field (when (cmn/curact form-atom :stockorder/blind-receipt) [:error]))}
      [:label.checkbox-label
       (form/checkbox-raw
         (rum/cursor stockorder-atom :stockorder/blind-receipt)
         {:disabled true})
       [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]
       [:span.checkbox__text
        [:span.checkbox__title "Blind Receipt"]]]
      (form/error-block (rum/cursor form-atom :stockorder/blind-receipt))]

     [:div.form-field
      (rum/with-key
        (datepicker/datepicker app-atom "Date:" "dd/mm/yyyy"
          [page :stockorder :stockorder/dateadded]
          {:header "Date"
           :datatype :date/dmy
           :disabled true})
        "shipping-date")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-select action-atom :stockorder :stockorder/destination_id "Warehouse:"
          (concat
            [{:text "- Select -" :value nil}]
            (map
              (fn [v]
                {:text (:name v) :value (:id v)})
              warehouses))
          {:disabled order-cancelled?
           :change-fn
           (fn [_n v]
             (let [{:keys [shipping-display-line-1 shipping-display-line-2]}
                   (so.cmn/shipping-address
                     (get warehouses-idx (trf/tonumber v)))]
               (swap! stockorder-atom assoc
                 :shipping/display-line-1 shipping-display-line-1
                 :shipping/display-line-2 shipping-display-line-2)))})
        "warehouse")]

     [:div
      {:class (yuc/bem :form-field (when (cmn/curact form-atom :stockorder/ship-to-diff-company?) [:error]))}
      [:label.checkbox-label
       (form/checkbox-raw
         (rum/cursor stockorder-atom :stockorder/ship-to-diff-company?)
         {:disabled true})
       [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]
       [:span.checkbox__text [:span.checkbox__title "Ship to different company"]]]
      (form/error-block (rum/cursor form-atom :stockorder/ship-to-diff-company?))]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-input action-atom :stockorder :shipping/display-line-1 "Address line 1:" ""
          {:disabled true}) "shipping-address-line-1")]

     [:div.form-field
      (rum/with-key
        (w.cmn/form-input action-atom :stockorder :shipping/display-line-2 "Address line 2:" ""
          {:disabled true}) "shipping-address-line-2")]]))

(rum/defc stock-order-overview < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder-atom (rum/cursor action-atom :stockorder)
        stockorder (rum/react stockorder-atom)
        api-response-atom (rum/cursor action-atom :api-response)
        api-response (rum/react api-response-atom)
        form-atom (rum/cursor-in action-atom [:form :stockorder])
        dear-sync (cmn/curact action-atom :dear-sync/method)
        import-order-id (:stockorder/import_order_id stockorder)
        order-cancelled? (= (:stockorder/status stockorder) "Cancelled")
        override-stock-order (cmn/curact action-atom :override-stock-order)
        invoice (cmn/curact action-atom :invoice)
        invoice-status (or (:status invoice) "N/A")
        order-status (:stockorder/status stockorder)
        stockorder-items (cmn/curact action-atom :order.table)
        receiving-status (so.cmn/calculate-receiving-status action-atom)]

    [:<>
     (headings/heading "Stock order:" {:type :h1 :size :default :flush true})
     [:div.u-margin-bottom-30
      {:class
       (yuc/bem :flex-grid-group [:valign-middle :align-left :flush-force])}
      [:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (headings/heading
          (str "#" (:stockorder/ourref stockorder)
            ": "
            (:supplier/name stockorder))
          {:type :h1
           :size :large
           :flush true})]]
      [:div
       {:class (yuc/bem :flex-grid-block [:align-right :fluid])}
       [:div.flex-grid-content
        [:div
         {:class
          (yuc/bem :flex-grid-group [:valign-middle :align-left :flush-force])}
         [:div
          {:class (yuc/bem :flex-grid-block [:fluid])}
          [:div.flex-grid-content
           (buttons/button-web "Back"
             {:style :secondary
              :icon :arrow-left
              :on-click #(urlstate/back)})]]]]]]

     [:div.u-margin-bottom-30
      {:class (yuc/bem :card [:no-hover] :text-card [:small])}
      [:div
       {:class (yuc/bem :flex-grid-group [:align-left :valign-middle :flush])}
       [:div
        {:class (yuc/bem :flex-grid-block [:ml-grow-yes :ml-fluid])}
        [:div.flex-grid-content
         [:div
          {:class
           (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
          [:div
           {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
           [:div.flex-grid-content
            [:div
             {:class
              (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
             [:div
              {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
              [:div.flex-grid-content [:b "Order status:"]]]
             [:div
              {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
              [:div.flex-grid-content
               [:span
                {:class (yuc/bem :text-pill [:dark :medium])}
                (translate-order-status order-status stockorder-items)]]]]]]
          [:div
           {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
           [:div.flex-grid-content
            [:div
             {:class
              (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
             [:div
              {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
              [:div.flex-grid-content [:b "Receiving status:"]]]
             [:div
              {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
              [:div.flex-grid-content
               [:span
                {:class (yuc/bem :text-pill [:dark :medium])}
                receiving-status]]]]]]
          [:div
           {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
           [:div.flex-grid-content
            [:div
             {:class
              (yuc/bem :flex-grid-group [:valign-middle :flush :align-left])}
             [:div
              {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
              [:div.flex-grid-content [:b "Invoice status:"]]]
             [:div
              {:class (yuc/bem :flex-grid-block [:shrink-0 :fluid])}
              [:div.flex-grid-content
               [:span
                {:class (yuc/bem :text-pill [:dark :medium])}
                invoice-status]]]]]]]]]

       [:div
        {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
        [:div.flex-grid-content
         [:div.u-margin-bottom-30
          {:class
           (yuc/bem
             :flex-grid-group
             [:valign-middle :align-left :flush-force])}
          [:div
           {:class (yuc/bem :flex-grid-block [:fluid])}
           (buttons/button-web
             (cond
               override-stock-order
               "Disable override"

               :else
               "Override stock order")
             (merge
               (urlstate/href-on-click
                 #(cond
                    override-stock-order
                    (grid/dispatch-action app-atom :admin.wholesale/stock-order.override-stock-order
                      {:uuid (:stockorder/uuid stockorder)})

                    :else
                    (grid/single-input-modal app-atom
                      {:title "Override stock order"
                       :text "This action will allow you to edit items on the Order Tab"
                       :cancel-text "Cancel"
                       :save-key :admin.wholesale/stock-order.override-stock-order
                       :input-key :override-reason
                       :field-text "Reason"
                       :auto-focus true})))
               {:style :negative
                :size :small
                :icon :wrench}))]
          [:div
           {:class (yuc/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (buttons/button-web "View in Weber"
              {:href (str "https://weber.yuppiechef.com/admin/reports/history/" (:stockorder/uuid stockorder))
               :style :secondary
               :size :small
               :target "_blank"})]]
          [:div
           {:class (yuc/bem :flex-grid-block [:fluid])}
           [:div.flex-grid-content
            (if (not import-order-id)
              (buttons/button-web "Create Import Order"
                {:size :small
                 :style :secondary
                 :on-click #(grid/dispatch-action app-atom :admin.wholesale/stockorder.create-import-order {})
                 :disabled
                 (not
                   (and
                     (contains? #{"Draft" "Placed"} (:stockorder/status stockorder))
                     (cmn/has-any-permission? app-atom io.cmn/import-order-edit-permission)))})
              (buttons/button-web (str "View Import Order - IO-" import-order-id)
                {:size :small
                 :style :secondary
                 :on-click
                 #(grid/dispatch-action app-atom :admin.wholesale/stockorder.view-import-order
                    {:import-order-id import-order-id})}))]]

          [:div
           {:class (yuc/bem :flex-grid-block [:fluid])}
           (buttons/button-web "Cancel stock order"
             (merge
               (urlstate/href-on-click
                 #(grid/confirm-modal app-atom
                    {:confirm-key :admin.wholesale/stock-order.cancel-stock-order
                     :title "Cancel Order"
                     :text "Are you sure you want to cancel this order? (This action cannot be undone)"
                     :confirm-text "Yes, Cancel Order"
                     :cancel-text "No"
                     :negative true
                     :stockorder-uuid (:stockorder/uuid stockorder)}))
               {:disabled (or order-cancelled? (contains? #{"Received" "Partially Received"} receiving-status))
                :size :small
                :style :negative}))]]]]]]

     (when (yuc/presence api-response)
       (let [{:keys [Message MessageDetail]} (:response api-response)]
         [:div
          {:class (yuc/bem :flex-grid-block [:fluid :flush :grow-yes])}
          (feedback/feedback
            (if (:success api-response) :success :warning)
            (or Message (:msg api-response))
            MessageDetail
            (rum/cursor api-response-atom :close-feedback))]))

     (when (= dear-sync :pull)
       (feedback/feedback :warning "System is set to sync Stock Orders from DEAR"
         [:span
          [:span "If you need to make changes to the Stock Order. Please make the changes in DEAR: Purchase Order."]
          [:br]
          [:span "Allow for the system to sync, roughly 30 minutes starting at 10 minutes past the hour."]]))

     [:div.u-margin-bottom-30
      {:class (yuc/bem :accordion [:card])}
      [:h3.accordion__heading
       [:a
        {:on-click #(swap! stockorder-atom update :open? not)
         :class (yuc/bem :accordion__heading-link [(when (:open? stockorder) :is-active)])}
        [:span.accordion__heading-text "Stock order details"]
        [:span.accordion__heading-icon-wrapper
         [:i.accordion__heading-icon.js-accordion-icon
          {:class (yuc/bem :icon [:block :default :is-dark (if (:open? stockorder) :minus :plus)])}]]]]
      (when (:open? stockorder)
        [:div.admin-action-item__content.u-margin-top-20
         [:div
          {:class (yuc/bem :flex-grid-group [:flush-force :align-left])}
          [:div
           {:class (yuc/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (supplier-details app-atom)]]
          [:div
           {:class (yuc/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (accounting-details app-atom)]]
          [:div
           {:class (yuc/bem :flex-grid-block [:m-1-3])}
           [:div.flex-grid-content
            (shipping-details app-atom)]]]
         [:div
          {:class (yuc/bem :flex-grid-block [:full])}
          [:div.flex-grid-content
           [:div
            {:class (when (cmn/curact form-atom :stockorder/message) [:error :form-field--error])}
            (headings/heading "Supplier comments" {:type :h4 :size :tiny :class "u-margin-bottom-24"})
            (form/textarea-raw (rum/cursor stockorder-atom :stockorder/message)
              {:disabled order-cancelled?})
            (form/error-block (rum/cursor form-atom :stockorder/message))]]]
         [:div
          {:class (yuc/bem :flex-grid-block [:full])}
          [:div
           {:class (yuc/bem :flex-grid-group [:align-left :flush-force])}
           [:div
            {:class (yuc/bem :flex-grid-block [:m-fluid])}
            [:div.flex-grid-content
             (buttons/button-web "Save"
               (merge
                 (urlstate/href-on-click
                   #(grid/dispatch-action app-atom
                      :admin.wholesale/stock-order.save {}))
                 {:style :primary
                  :disabled (or order-cancelled? (= dear-sync :pull))
                  :class "u-margin-bottom-24 u-min-width-240"}))]]]]])]

     (tabs/tabbed-content
       ""
       ""
       [(tabs/tab
          "Order"
          [(order.tab/stock-order-products app-atom)]
          {:id "order"
           :icon :package})
        (tabs/tab-action
          "Invoice"
          [(invoice.form/stock-order-invoice app-atom)]
          {:id "invoice"
           :icon :cash
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/invoice-tab.initiate {})})
        (tabs/tab-action
          "Stock Received"
          [(stockreceived.wrapper/stock-order-stock-received app-atom)]
          {:id "stock-received"
           :icon :package-in
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/receiving-tab.initiate {})})
        (tabs/tab-action
          "Credit Note"
          [(creditnote.wrapper/credit-notes app-atom)]
          {:id "credit-note"
           :icon :document
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/creditnote-tab.initiate {})})
        (tabs/tab-action
          "Manual Journals"
          [(manualjournals/display-manual-journals app-atom)]
          {:id "manual-journals"
           :icon :pencil
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/stock-order.manual-journals.item-list {})})
        (tabs/tab-action
          "Attachments"
          [(attachments/attachments-tab app-atom)]
          {:id "attachments"
           :icon :attachment
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/stock-order.attachment.item-list {})})
        (tabs/tab-action
          "Change Logs"
          [(changelogs/display-changelogs app-atom)]
          {:id "changelogs"
           :icon :document
           :on-click-fn
           #(grid/dispatch-action app-atom :admin.wholesale/stockorder.changelogs.init {})})])
     (toaster/loading-overlay app-atom :admin.wholesale/stock-order.overview)]))

(defmethod grid/action :admin.wholesale/stockorder.view-import-order [app-atom _ _]
  (toaster/open-overlay app-atom :admin.wholesale/stock-order.overview)
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder (cmn/curact action-atom :stockorder)]
    (cond
      (cmn/has-any-permission? app-atom io.cmn/api-permissions)
      (comms/send :admin.wholesale/stockorder.view-import-order {:uuid (:stockorder/uuid stockorder)})

      :else
      (grid/open-modal app-atom :grid/message
        {:title "Warning"
         :text
         (feedback/feedback :warning
           [:b "Insufficient permissions to View this Stock Order"]
           [:span
            [:p "Please contact IT and request the permission required."]])}))))

(defmethod comms/receive :admin.wholesale/stockorder.view-import-order [app-atom {:keys [import-order-uuid]}]
  (toaster/close-overlay app-atom :admin.wholesale/stock-order.overview)
  (urlstate/redirect app-atom "wholesale" "import_order_overview" {:uuid import-order-uuid}))

(defmethod grid/action :admin.wholesale/stockorder.create-import-order [app-atom _ _]
  (toaster/open-overlay app-atom :admin.wholesale/stock-order.overview)
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder (cmn/curact action-atom :stockorder)]
    (comms/send :admin.wholesale/stockorder.create-import-order
      {:stockorder/uuid (:stockorder/uuid stockorder)})))

(defmethod comms/receive :admin.wholesale/stockorder.create-import-order [app-atom {:keys [import-order-uuid]}]
  (toaster/close-overlay app-atom :admin.wholesale/stock-order.overview)
  (urlstate/redirect app-atom "wholesale" "import_order_overview" {:uuid import-order-uuid}))

(defmethod grid/action :admin.wholesale/stock-order.save [app-atom _ _]
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder (cmn/curact action-atom :stockorder)
        dear-sync (cmn/curact action-atom :dear-sync/method)]
    (cond
      (= dear-sync :pull)
      (grid/open-modal app-atom :grid/message
        {:title "Warning"
         :text
         (feedback/feedback :warning
           [:b "The system is set to sync from Dear"]
           [:span
            [:p "The system is set to pull information from Dear, saving has been disabled."]])})

      :else
      (let [form-fields (cmn/curact action-atom [:form :stockorder])
            form-field-keys (keys form-fields)
            fields-with-errors (filter #(yuc/presence (get-in form-fields [% :error])) form-field-keys)]
        (toaster/open-overlay app-atom :admin.wholesale/stock-order.overview)
        (when (not (empty? fields-with-errors))
          (swap! action-atom update-in [:form :stockorder]
            (fn [form-fields]
              (reduce
                (fn [acc field-key]
                  (update acc field-key dissoc :error))
                form-fields fields-with-errors))))
        (comms/send :admin.wholesale/stockorders.edit
          {:action :edit :data [stockorder]})))))

(defmethod comms/receive :admin.wholesale/stockorders.edit [app-atom {:keys [rows field-errors]}]
  (toaster/close-overlay app-atom :admin.wholesale/stock-order.overview)
  (let [action-atom (cmn/action-cursor app-atom)
        action-name (cmn/action-cursor-path app-atom)
        stockorder (cmn/curact action-atom :stockorder)
        import-order (cmn/curact action-atom :import-order)]

    (cond
      field-errors
      (swap! action-atom update-in [:form :stockorder] merge
        (w.cmn/overview-field-errors field-errors))

      :else
      (let [rows-idx (yuc/index-by :stockorder/id rows)
            row (get rows-idx (:stockorder/id stockorder))]

        (when (and (nil? import-order) (yuc/presence (:stockorder/import_order_id row)))
          (grid/dispatch-action app-atom :admin.wholesale/stockorder.import-order-details
            {:uuid (:stockorder/uuid stockorder)}))

        (swap! app-atom update action-name
          (fn [action]
            (->
              action
              (assoc :api-response (:api-response row))
              (update :stockorder #(merge % (dissoc row :api-response)))
              (update-in [:form]
                (fn [form-entity]
                  (let [field-keys (keys row)]
                    (reduce
                      (fn [acc field-key]
                        (let [new-value (get row field-key)]
                          (cond
                            (get-in acc [:stockorder field-key])
                            (update-in acc [:stockorder field-key] assoc :value new-value)

                            :else
                            acc)))
                      form-entity field-keys)))))))))))

(defmethod flow/render-screen :admin.wholesale/stockorder_overview [app-atom _]
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder (cmn/curact action-atom :stockorder)
        screen-params (cmn/screen-params app-atom)]
    [:div {:style {:position "relative"}}
     [:div {:style {:position "absolute" :top 0 :right 0 :z-index 1}}
      ;; The v2=1 param lets the server set the authoritative (path=/) preference
      ;; cookie. We deliberately avoid a client-side cookie write here, which the
      ;; classic client scopes to the document path (/admin) and which would then
      ;; shadow the canonical cookie.
      (buttons/button-web "Try new layout"
        {:href (str "wholesale.htm?action=stockorder_overview&uuid=" (:uuid screen-params) "&v2=1")
         :style :light
         :size :small})]
     (w.cmn/wholesale-wrapper app-atom
       {:main-page "Stock Orders"
        :main-action "stockorders"
        :current-page-title (str "Overview of #" (:stockorder/ourref stockorder))
        :confirm-leave false
        :confirm-leave-modal-key :admin.wholesale/check.unsaved-changes}
       (stock-order-overview app-atom))]))

(defmethod t/transition-open :admin.wholesale/stockorder_overview [app-atom _ params]
  (w.cmn/redirect-to-new-layout-if-needed! app-atom "wholesale.stockorder_overview" params))

(defmethod t/transition-after-open :admin.wholesale/stockorder_overview [app-atom _ _]
  (toaster/open-overlay app-atom :admin.wholesale/stock-order.overview)
  (dcommon/kill-search-bar)
  (let [action-atom (cmn/action-cursor app-atom)
        current-stockorder (cmn/curact action-atom :stockorder)
        screen-params (cmn/screen-params app-atom)]
    (datatables/overlay app-atom :open order.cfg/datatables-order-key)
    (datatables/overlay app-atom :open order.cfg/datatables-additional-charges-key)
    (comms/send :admin.wholesale/stockorder.order.list {:stockorder/uuid (:uuid screen-params)})
    (swap! action-atom assoc
      :reset-page? (not= (str (:uuid screen-params)) (:stockorder/uuid current-stockorder))
      :stockorder {:stockorder/uuid (str (:uuid screen-params))})
    (comms/send :admin.wholesale/stockorder.overview {:uuid (:uuid screen-params)})))

(defmethod comms/receive :admin.wholesale/stockorder.overview
  [app-atom
   {:keys
    [stockorder freight-forwarders suppliers supplier-contacts supplier-addresses
     inventory-account shipping-province payment-terms tax-rules warehouses currencies] :as e}]
  (toaster/close-overlay app-atom :admin.wholesale/stock-order.overview)
  (let [action-atom (cmn/action-cursor app-atom)
        action-atom-path (cmn/action-cursor-path app-atom)
        reset-page? (cmn/curact action-atom :reset-page?)]

    (swap! app-atom update action-atom-path
      (fn [action]
        (let [merged-stockorder (merge (:stockorder action {}) stockorder)]
          (->
            action
            (assoc
              :dear-sync/method (:dear-sync/method e)
              :reset-page? false
              :stockorder merged-stockorder
              :suppliers (sort-by :name suppliers)
              :supplier-addresses supplier-addresses
              :supplier-contacts supplier-contacts
              :inventory-account inventory-account
              :shipping-province shipping-province
              :payment-terms payment-terms
              :tax-rules tax-rules
              :warehouses warehouses
              :freight-forwarders freight-forwarders
              :currencies (yuc/index-by :code currencies))
            (update-in [:form]
              (fn [form-entity]
                (let [field-keys (keys merged-stockorder)]
                  (reduce
                    (fn [acc field-key]
                      (let [new-value (get merged-stockorder field-key)]
                        (update-in acc [:stockorder field-key] assoc :value new-value)))
                    form-entity field-keys))))))))

    (when reset-page?
      (datatables/reset-data app-atom (order.cfg/grid-columns app-atom) order.cfg/datatable-fns)
      (datatables/reset-data app-atom (order.cfg/additional-charges-config app-atom) order.cfg/additional-charges-table-fns))

    (when (yuc/presence (:stockorder/id stockorder))
      (datatables/initiate app-atom (order.cfg/grid-columns app-atom) order.cfg/datatable-fns)
      (datatables/initiate app-atom (order.cfg/additional-charges-config app-atom) order.cfg/additional-charges-table-fns)
      (editor/initiate app-atom (order.cfg/editor-config app-atom))
      (editor/initiate app-atom (order.cfg/additional-charges-editor app-atom)))
    (presence/open app-atom {:ent/uuid (yuc/uuid (:stockorder/uuid stockorder)) :context/type :stockorder})))

(defmethod comms/receive :admin.wholesale/stockorder.item-info [app-atom e]
  (let [action-atom (cmn/action-cursor app-atom)]
    (cond
      (yuc/presence (:stock/details e))
      (swap! action-atom assoc :stockorder/stock-details (:stock/details e))

      (yuc/presence (:variation/details e))
      (swap! action-atom update-in
        [:stockorder/stock-details :variation/details]
        merge (:variation/details e)))))

(defmethod comms/receive :admin.wholesale/stock-order.cancel-stock-order [app-atom]
  (urlstate/redirect app-atom "wholesale" "stockorders")
  (comms/send :admin.wholesale/stockorders.list {}))

;;------------------------------------------------------------------------------------------------------------------------------
;; Stock Order : Override
;;------------------------------------------------------------------------------------------------------------------------------

(defmethod grid/action :admin.wholesale/stock-order.override-stock-order [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        stockorder (cmn/curact action-atom :stockorder)
        permission?
        (or
          (cmn/has-permission? app-atom "SiteAdmin:Teams:Development")
          (cmn/has-permission? app-atom "SiteAdmin:Wholesale:StockOrder:Override")
          (cmn/has-permission? app-atom "SiteAdmin:Teams:Finance"))
        override-stock-order (cmn/curact action-atom :override-stock-order)]

    (cond
      override-stock-order
      (do
        (toaster/open-toast app-atom :warning "Disabling override" {:closetime 4000})
        (swap! action-atom assoc :override-stock-order false)
        (order.cfg/reset-order-table-buttons app-atom))

      permission?
      (do
        (toaster/open-overlay app-atom :admin.wholesale/stock-order.overview {:text "Authorising Override"})
        (comms/send :admin.wholesale/stockorder.order-override
          {:uuid (:stockorder/uuid stockorder)
           :override-reason (:override-reason config)}))

      :else
      (grid/dispatch-action app-atom :admin.wholesale/wholesale.unauthorised-warning
        {:permission "SiteAdmin:Wholesale:StockOrder:Override"}))))

(defmethod comms/receive :admin.wholesale/stockorder.order-override [app-atom {:keys [override?]}]
  (toaster/close-overlay app-atom :admin.wholesale/stock-order.overview)
  (toaster/open-toast app-atom :warning "Enabling override" {:closetime 4000})
  (let [action-atom (cmn/action-cursor app-atom)]
    (when override?
      (swap! action-atom assoc :override-stock-order true)
      (order.cfg/reset-order-table-buttons app-atom))))